import { Box } from "@mui/material";
import { contentStyle } from "./styles";

const Content = ({ children, width }) => {
  return <Box sx={() => contentStyle(width)}>{children}</Box>;
};

export default Content;
